// angular import
import { Component, OnInit, output, inject, NgZone } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

// project import
import { SharedModule } from 'src/app/theme/shared/shared.module';
import { NavLeftComponent } from './nav-left/nav-left.component';
import { NavRightComponent } from './nav-right/nav-right.component';
import { GradientConfig } from 'src/app/app-config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-bar',
  imports: [SharedModule, NavLeftComponent, NavRightComponent, RouterModule, CommonModule],
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  // public props
  gradientConfig;
  menuClass: boolean;
  collapseStyle: string;
  windowWidth: number;
  companyLogo: string = '';
  home_page: any = '/dashboard/analytics';
  companyfavicon: string = '';
  NavCollapse = output();
  NavCollapsedMob = output();
  private ngZone = inject(NgZone);
  // constructor
  constructor() {
    this.gradientConfig = GradientConfig;
    this.menuClass = false;
    this.collapseStyle = 'none';
    this.windowWidth = window.innerWidth;
  }

  // public method
  toggleMobOption() {
    this.menuClass = !this.menuClass;
    this.collapseStyle = this.menuClass ? 'block' : 'none';
  }

  navCollapse() {
    if (this.windowWidth >= 992) {
      this.NavCollapse.emit();
    }
  }
  ngOnInit() {
    const storedUser = localStorage.getItem('currentUser');

    if (storedUser) {
      const userData = JSON.parse(storedUser);

      this.companyLogo = this.getMedia(userData?.user?.logo, 'assets/dev_images/auth/PerformoLabs-185-48.png');
      this.companyfavicon = this.getMedia(userData?.user?.favicon, 'assets/images/logo-icon.png');
      this.home_page = userData.user.home_page;
      this.updateFavicon(this.companyfavicon + '?v=' + new Date().getTime());
    }
  }
  updateFavicon(iconUrl: string) {
    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.type = iconUrl.endsWith('.ico') ? 'image/x-icon' : 'image/png';
    link.href = iconUrl;
  }
  getMedia(obj: any, fallback: string) {
    const value = typeof obj === 'object' ? obj?.logo || obj?.favicon : obj;

    return value && value !== 'null'
      ? `${environment.cdnUrl}/${value}`
      : fallback;
  }

  navCollapseMob() {
    if (this.windowWidth < 992) {
      this.NavCollapsedMob.emit();
    }
  }
}
